import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'

const isDarkAtom = atom(
  typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)').matches : false,
)

/** Call once at app root to set up the matchMedia listener */
export function useIsDarkListener() {
  const setIsDark = useSetAtom(isDarkAtom)

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    setIsDark(mq.matches)
    const handler = (e: MediaQueryListEvent) => setIsDark(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [setIsDark])
}

/** Read dark mode state from anywhere — requires useIsDarkListener at root */
export function useIsDark() {
  return useAtomValue(isDarkAtom)
}
